import { render } from "./questionItem.vue?vue&type=template&id=32df1014"
import script from "./questionItem.vue?vue&type=script&lang=js"
export * from "./questionItem.vue?vue&type=script&lang=js"

import "./questionItem.vue?vue&type=style&index=0&id=32df1014&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__